export const DEFAULT_NO_DATA_MESSAGE =
  'No report data for the selected filter. PDF download was canceled.';
export const WEEKLY_MINUTE_RANGE_MESSAGE =
  'Minute interval is limited to 7 days.';

export const isNoDataMessage = (value: string) => {
  const normalizedValue = value.toLowerCase();
  return (
    normalizedValue.includes('no data') ||
    normalizedValue.includes('data report kosong') ||
    normalizedValue.includes('tidak ada data')
  );
};

export const isMinuteRangeExceededMessage = (value: string) => {
  const normalizedValue = value.toLowerCase();
  return (
    normalizedValue.includes('weekly minute report range') ||
    normalizedValue.includes('monthly minute report range') ||
    normalizedValue.includes('err_report_log_weekly_minute_range_exceeded')
  );
};

export type PdfDownloadErrorModal = {
  title: string;
  content: string;
};

export function resolvePdfDownloadErrorModal(params: {
  statusCode?: number;
  errorMessage?: string;
}): PdfDownloadErrorModal {
  const errorMessage = params.errorMessage?.trim();

  if (params.statusCode === 400) {
    if (errorMessage && isMinuteRangeExceededMessage(errorMessage)) {
      return {
        title: 'Export not available',
        content: errorMessage.toLowerCase().includes('weekly')
          ? WEEKLY_MINUTE_RANGE_MESSAGE
          : errorMessage,
      };
    }

    if (errorMessage && isNoDataMessage(errorMessage)) {
      return {
        title: 'No Data',
        content: DEFAULT_NO_DATA_MESSAGE,
      };
    }

    if (errorMessage) {
      return {
        title: 'Download canceled',
        content: errorMessage,
      };
    }

    return {
      title: 'No Data',
      content: DEFAULT_NO_DATA_MESSAGE,
    };
  }

  return {
    title: 'Download Failed',
    content: errorMessage || 'Failed to generate report PDF. Please try again.',
  };
}
